<div class="img-wrapper">
	<div class="lable-block">
		<span class="lable3" *ngIf='product.newItem' i18n="@@New">New</span>
		<!-- <span class="lable4" *ngIf='product.sale' i18n="@@ReducedPrice">Reduced price</span> -->
	</div>
	<div class="front">
		<a [routerLink]="[routerLinkUrl]" [queryParams]="{itm: product?.id}" class="product-image-container">
			<img *ngIf="primaryImage" [attr.src]="primaryImage" style="max-width: 100%;max-height: 100%"
				onError="this.src='assets/images/img-not-available.png';" class="image-center product-image img-fluid"
				alt="{{product?.alt}}"
				[attr.loading]="index < 4 ? 'eager' : 'lazy'"
				[attr.fetchpriority]="index < 2 ? 'high' : null">
			<img *ngIf="secondaryImage && isMiloTheme" [attr.src]="secondaryImage" style="max-width: 100%;max-height: 100%"
				onError="this.src='assets/images/img-not-available.png';" class="image-center product-image-hover img-fluid"
				alt="{{product?.alt}}"
				[attr.loading]="index < 4 ? 'eager' : 'lazy'">
		</a>
	</div>
</div>
<div class="product-detail-new">
	<bar-rating [rate]="product?.ratingInfo?.rating" [theme]="'default'"
		(rateChange)="updateRating($event)"></bar-rating>
	<a [routerLink]="[routerLinkUrl]" [queryParams]="{itm: product?.id}">
		<p class="product-detail-new--h6" title="{{product.name}}">{{product.name}}</p>
	</a>
	<div class="sale-percentage" *ngIf="product?.sale_price_percentage">
		- {{ product?.sale_price_percentage }} %
	</div>
	<ng-container *ngIf="company && !company?.allCompanySettings?.shopPriceWithTax">
		<ng-container *ngIf="product?.sale_price_percentage && product?.sale_price_percentage > 0">
			<h4 class="product-detail-new--h4">
				{{product?.sale_price_without_tax?.amount | currency:product?.sale_price_without_tax?.currency:'symbol'
				: '1.0-2'}}
				<del>{{product.priceWithoutTax?.amount | currency:product?.priceWithoutTax?.currency:'symbol' :
					'1.0-2'}}</del>
			</h4>
			<span style="color: #e3141a; font-size: 12px; font-weight: 500; margin-top: 2px;display: block;">Ušteda: {{
				product.priceWithoutTax?.amount - product?.sale_price_without_tax?.amount | number: "1.0-2"}}
				{{product?.priceWithoutTax?.currency | lowercase}}</span>
			<div class="product-tax">+
				{{ product?.taxRate?.rate }}% <span i18n="@@Pdv">PDV</span>
			</div>
		</ng-container>
		<ng-container *ngIf="!(product?.sale_price_percentage && product?.sale_price_percentage > 0)">
			<h4 class="product-detail-new--h4">
				{{product?.priceWithoutTax?.amount | currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}
			</h4>
			<div class="product-tax">+
				{{ product?.taxRate?.rate }}% <span i18n="@@Pdv">PDV</span>
				</div>
		</ng-container>
	</ng-container>

	<ng-container *ngIf="company && company?.allCompanySettings?.shopPriceWithTax">
		<ng-container *ngIf="product?.sale_price_percentage && product?.sale_price_percentage > 0">
			<h4 class="product-detail-new--h4">
				{{ (product?.sale_price_without_tax?.amount * ((product?.taxRate?.rate / 100) + 1)) | number: "1.2-2" }}
				<del style="font-size: 14px;">{{(product.priceWithoutTax?.amount * ((product?.taxRate?.rate / 100) + 1))
					| currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}</del>
			</h4>
		</ng-container>
		<ng-container *ngIf="!(product?.sale_price_percentage && product?.sale_price_percentage > 0)">
			<h4 class="product-detail-new--h4">
				{{ (product?.priceWithoutTax?.amount * ((product?.taxRate?.rate / 100) + 1)) |
				currency:product?.priceWithoutTax?.currency:'symbol' : '1.0-2'}}
			</h4>
		</ng-container>
	</ng-container>

	<ul class="color-variant" *ngIf="product.variants">
		<li [class]="variant.color" (click)="changeVariantImage(variant.images)"
			*ngFor="let variant of product.variants"></li>
	</ul>
</div>